import React from 'react';
import ExpiredInvitation from './ExpiredInvitation';

const ExpiredInvitationContainer = () => {
  return <ExpiredInvitation />;
};

export default ExpiredInvitationContainer;
